import { render } from "./Footer.vue?vue&type=template&id=0d099289&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0d099289&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Benjamin\\Desktop\\Hudplejeklinikken Esbjerg\\code\\hpke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d099289"]])

export default __exports__